// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { PFixFieldSet } from '../Fields/FieldsImport.js'
import { FieldsFactory } from '../Factory/FieldsFactory.js'
import { UrlGroup, SupportedAggregationsGroup } from './GroupsImport.js'

var ClusterNodeGroup = function (pfixFieldSet)
{
    PFixFieldSet.call(
      this, FieldsFactory.CLUSTER_NODE_GROUP, null, pfixFieldSet)
}

ClusterNodeGroup.prototype = Object.create(PFixFieldSet.prototype)

ClusterNodeGroup.prototype.getNodeID = function ()
{
    return this.GetValue(FieldsFactory.FIELD_NODE_ID)
}

ClusterNodeGroup.prototype.getNodeLoad = function ()
{
    return this.GetValue(FieldsFactory.FIELD_NODE_LOAD)
}

ClusterNodeGroup.prototype.getConnectionMode = function ()
{
    return this.GetValue(FieldsFactory.FIELD_CONNECTION_MODE)
}

ClusterNodeGroup.prototype.GetUrls = function ()
{
    return this.GetGroups(FieldsFactory.SERVER_URL_GROUP, UrlGroup)
}

ClusterNodeGroup.prototype.GetUrl = function (useSSL)
{
    let groups = this.GetUrls()
    // дима утверждает, что если подходящего режима (ссл или не-ссл) нет,
    // то не подключаться вообще на эту ноду. Могут быть трудновыявл проблемы.
    for (let i = 0, len = groups.length; i < len; i++)
    {
        let url = groups[i]
        let protocol = url.getProtocol()
        // тут по идее нужно анализировать загрузку, ну да пох пока на нее
        if ((useSSL && protocol === 1) || (!useSSL && protocol === 0))
        {
            return url.getValue()
        }
    }
    // TODO. Remove?
    // когда неправильный формат (старый) на сервере - нет филда протокол,
    // беру любой адрес, полагая его ссл/нессл по моей локальной настройке
    for (let i = 0, len = groups.length; i < len; i++)
    {
        let url = groups[i]
        if (!url.IsSetField(FieldsFactory.FIELD_ADDRESS_PROTOCOL))
        {
            return url.getValue()
        }
    }

    // TODO.
    console.log(
      "Node ID='" +
      this.getNodeID() +
      "' hasn't any URL for '" +
      useSSL ? 'Secure' : 'Non-secure' + "' mode ")

    return null
}

ClusterNodeGroup.prototype.GetUrlsPair = function ()
{
    let groups = this.GetUrls()
    // дима утверждает, что если подходящего режима (ссл или не-ссл) нет,
    // то не подключаться вообще на эту ноду. Могут быть трудновыявл проблемы.
    let result = new Object();
    for (let i = 0, len = groups.length; i < len; i++)
    {
        let url = groups[i];
        let protocol = url.getProtocol();
        if (protocol === 1)
            result["useSSL"] = url.getValue();
        else if (protocol === 0)
            result["noSSL"] = url.getValue();
    }

    return result;
}

ClusterNodeGroup.prototype.SupportedAggregationsGroups = function ()
{
    return this.GetGroups(FieldsFactory.SUPPORTED_AGGREGATIONS_GROUP, SupportedAggregationsGroup)
}

export { ClusterNodeGroup }